import { render } from "./AddFacilityService.vue?vue&type=template&id=3e0157d6"
import script from "./AddFacilityService.vue?vue&type=script&lang=js"
export * from "./AddFacilityService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__